import { Pipe, PipeTransform } from '@angular/core';
import { formatTrackedTimeLong, formatTrackedTimeShort } from './format.util';

export type TrackedTimeFormatStyle = 'short' | 'long';

@Pipe({
    standalone: false,
    name: 'formatTrackedTime',
})
export class FormatTrackedTimePipe implements PipeTransform {
    transform(timeStamp: string | null | undefined, style: TrackedTimeFormatStyle = 'short'): string {
        if (!timeStamp) {
            return style === 'long' ? '00:00 hrs' : '00h 00m';
        }
        return style === 'long' ? formatTrackedTimeLong(timeStamp) : formatTrackedTimeShort(timeStamp);
    }
}
